import { render, staticRenderFns } from "./HistoricalGenericFilter.vue?vue&type=template&id=046994dc&scoped=true"
import script from "./HistoricalGenericFilter.vue?vue&type=script&lang=js"
export * from "./HistoricalGenericFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046994dc",
  null
  
)

export default component.exports